import React from 'react';

const baseInputStyles = "w-full p-2 border rounded-lg bg-transparent text-accent-900 dark:text-surface-50 border-accent-900 dark:border-surface-100 placeholder:text-accent-400 dark:placeholder:text-accent-500";

const labelStyles = "block mb-1.5 text-sm font-medium text-accent-700 dark:text-accent-300";

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

interface FieldProps {
  name: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  maxLength?: number;
}

interface InputFieldProps extends FieldProps {
  type?: string;
  autoComplete?: string;
}

export const InputField: React.FC<InputFieldProps> = ({
  name,
  label,
  type = 'text',
  value,
  onChange,
  required,
  placeholder,
  maxLength,
  autoComplete,
}) => {
  const id = `contact-${name}`;
  return (
    <div>
      <label htmlFor={id} className={labelStyles}>
        {label ?? capitalize(name)}
      </label>
      <input
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        maxLength={maxLength}
        autoComplete={autoComplete}
        className={baseInputStyles}
      />
    </div>
  );
};

export const TextAreaField: React.FC<FieldProps> = ({
  name,
  label,
  value,
  onChange,
  required,
  placeholder,
  maxLength,
}) => {
  const id = `contact-${name}`;
  return (
    <div>
      <label htmlFor={id} className={labelStyles}>
        {label ?? capitalize(name)}
      </label>
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        maxLength={maxLength}
        className={`${baseInputStyles} h-32`}
      />
    </div>
  );
};
